import axios from 'axios';
import {
  GET_USER_CONTRACT_REQUEST,
  GET_USER_CONTRACT_SUCCESS,
  GET_USER_CONTRACT_FAILURE,
  ACCEPT_KVKK_AGREEMENT_REQUEST,
  ACCEPT_KVKK_AGREEMENT_SUCCESS,
  ACCEPT_KVKK_AGREEMENT_FAILURE,
  GET_COMMERCIAL_MESSAGE_AGREEMENT_REQUEST,
  GET_COMMERCIAL_MESSAGE_AGREEMENT_SUCCESS,
  GET_COMMERCIAL_MESSAGE_AGREEMENT_FAILURE,
  GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_REQUEST,
  GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_SUCCESS,
  GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_FAILURE,

  GET_KVKK_AGREEMENT_REQUEST,
  GET_KVKK_AGREEMENT_SUCCESS,
  GET_KVKK_AGREEMENT_FAILURE,
} from 'Store/constants';
import { getChannel } from 'Utils/channel';
import errorMessage from 'Store/actions/errorMessage';
import { closeModal } from 'Store/actions';
import ProjectConfig from 'ProjectConfig';
import { GET_CHANCE_GAMES_AGREEMENT_FAILURE, GET_CHANCE_GAMES_AGREEMENT_REQUEST, GET_CHANCE_GAMES_AGREEMENT_SUCCESS, GET_CHANCE_GAMES_USER_AGREEMENT_FAILURE, GET_CHANCE_GAMES_USER_AGREEMENT_REQUEST, GET_CHANCE_GAMES_USER_AGREEMENT_SUCCESS } from '../constants';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

export const getUserContract = () => async dispatch => {
  try {
    dispatch({
      type: GET_USER_CONTRACT_REQUEST
    });

    const res = await axios.get(`${API_GATEWAY}/users/contracts`, {
      headers: {
        channel: getChannel()
      }
    });

    dispatch({
      type: GET_USER_CONTRACT_SUCCESS,
      payload: res.data
    });

  } catch (e) {

    dispatch({
      type: GET_USER_CONTRACT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const acceptKVKKagreement = (contractType, ignoreRequest) => async (dispatch, getState) => {

  if (!ignoreRequest) {
    try {
      dispatch({
        type: ACCEPT_KVKK_AGREEMENT_REQUEST
      });

      const isAlreadyAccepted = getState().membership.kvkk.isAccepted;

      if (isAlreadyAccepted) {
        return dispatch({
          type: ACCEPT_KVKK_AGREEMENT_SUCCESS,
          payload: false
        });
      }

      await axios.put(`${API_GATEWAY}/users/contracts/save?contractType=${contractType}`);

      dispatch({
        type: ACCEPT_KVKK_AGREEMENT_SUCCESS,
        payload: true
      });

    } catch (e) {

      dispatch({
        type: ACCEPT_KVKK_AGREEMENT_FAILURE,
        payload: e.response && e.response.data || errorMessage
      });
    }
  }
  dispatch(closeModal('KVKKModal'));
};

export const getCommercialMessageAgreement = () => async dispatch => {
  try {
    dispatch({
      type: GET_COMMERCIAL_MESSAGE_AGREEMENT_REQUEST
    });
    const res = await axios.get('/cms/userAgreement/latestCommercialMessageAgreement/');
    
    dispatch({
      type: GET_COMMERCIAL_MESSAGE_AGREEMENT_SUCCESS,
      payload: res.data
    });
    return res;
    
  } catch (e) {
    
    dispatch({
      type: GET_COMMERCIAL_MESSAGE_AGREEMENT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getKVKKagreement = type => async dispatch => {
  try {
    dispatch({
      type: GET_KVKK_AGREEMENT_REQUEST
    });
  
    const urlPath = type === '/kvkk' ? 'latestPrivacyAgreement' : 'latestCookiePreferencesAgreement/MW';
    
    const res = await axios.get(`/cms/userAgreement/${urlPath}`);

    dispatch({
      type: GET_KVKK_AGREEMENT_SUCCESS,
      payload: res.data
    });
    
  } catch (e) {
    
    dispatch({
      type: GET_KVKK_AGREEMENT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};


export const getRaffleCommercialMessageAgreement = () => async dispatch => {
  try {
    dispatch({
      type: GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_REQUEST
    });
  
    const res = await axios.get('/cms/userAgreement/latestRaffleAgreement/');
  
    dispatch({
      type: GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_SUCCESS,
      payload: res.data
    });

    return res;
  
  } catch (e) {
  
    dispatch({
      type: GET_RAFFLE_COMMERCIAL_MESSAGE_AGREEMENT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getChanceGamesAgreement = () => async dispatch => {
  try {
    dispatch({
      type: GET_CHANCE_GAMES_AGREEMENT_REQUEST
    });
  
    const res = await axios.get('/cms/userAgreement/latestDigitalGamesAgreement/');
  
    dispatch({
      type: GET_CHANCE_GAMES_AGREEMENT_SUCCESS,
      payload: res.data
    });

    return res;
  
  } catch (e) {
  
    dispatch({
      type: GET_CHANCE_GAMES_AGREEMENT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

export const getChanceGamesUserAgreement = () => async dispatch => {
  try {
    dispatch({
      type: GET_CHANCE_GAMES_USER_AGREEMENT_REQUEST
    });
  
    const res = await axios.get('/cms/userAgreement/latestDigitalGamesUserAgreement/');
  
    dispatch({
      type: GET_CHANCE_GAMES_USER_AGREEMENT_SUCCESS,
      payload: res.data
    });

    return res;
  
  } catch (e) {
  
    dispatch({
      type: GET_CHANCE_GAMES_USER_AGREEMENT_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};
